//Match title height

function MatchHeight() {
  
	$(".product-collection__title h2 a").matchHeight();
	$(".product-categories .cat_grid_item__title").matchHeight();
	$(".loop-product-stock .product-stock .product-stock-status").matchHeight();
   
}
MatchHeight();

$(window).on("load", function () {  
  MatchHeight();
});

const timeID = setInterval(matchheight2, 1000);
function matchheight2() {
   $(".product-collection__title h2 a").matchHeight();
   $(".product-categories .cat_grid_item__title").matchHeight();
}
$(window).on("load", function () {    
 matchheight2();
});